export default "__VITE_ASSET__089efac5__"